@if (groupHeader) { <row-details class="group-header" (click)="groupHeaderAction.emit()"><h2>{{ groupBy }}</h2></row-details> }
@if (subGroupHeader) { <row-details class="sub-group-header out-of-focus">{{ subGroupBy }}</row-details> }
<tr #row (click)="onClick()">
	@if (statusIcon || brand) {
		<column class="row-status" [attr.title]="statusTitle">
			@if (showCollapseIcon) { <icon (click)="toggleCollapsed($event)" [ngClass]="{ 'invisible': (collapsed === undefined) }" [type]="collapsed ? 'chevron-right' : 'chevron-down'" class="collapse-icon"></icon> }
			@if (statusIcon) { <icon class="status-icon" [type]="statusIcon" [ngStyle]="{ color: statusColor }"></icon> }
			@if (brand) { {{ brand.shortName }} }
		</column>
	}
	<ng-content select="column, hover-menu, menu"></ng-content>
</tr>
<ng-content></ng-content>
